import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';

import ChatInputComponent from '../../../components/chat-input/ChatInput';
import VoiceRecordButton from '../../../components/voice-record-button/VoiceRecordButton';
import FileAttachButton from '../../../components/file-attach-button/FileAttachButton';
import DropZone from '../../../components/chat-input/components/drop-zone/DropZone';

import scss from './ChatInput.module.scss';

const DEFAULT_ACCEPTED_FILE_TYPES = {
  'image/*': [],
  'video/*': [],
  'application/*': [],
};

function ChatInput({
  disabled,
  disableFileAttachments,

  isLoading = false,
  isError = false,
  errorText = '',

  acceptedFileTypes = DEFAULT_ACCEPTED_FILE_TYPES,

  onSubmit,

  value,
  onChange,
  onFocus,
  onBlur,

  attachments = [],
  onChangeAttachments,
}) {
  const { t } = useTranslation();
  const chatRef = useRef(null);

  const handleAttach = (files) => {
    const newAttachments = files.map((file) => ({
      id: uuidv4(),
      file,
    }));
    onChangeAttachments?.([...attachments, ...newAttachments]);
  };

  const handleRemoveAttachment = (id) => {
    const newAttachments = attachments.filter((attachment) => attachment.id !== id);
    onChangeAttachments?.(newAttachments);
  };

  const handleSend = async () => {
    await onSubmit();

    // chatRef.current?.focus?.();
  };

  useEffect(() => {
    if (disableFileAttachments && attachments.length > 0) {
      onChangeAttachments?.([]);
    }
  }, [disableFileAttachments, attachments.length]);

  return (
    <div className={scss.inputWrapper}>
      <DropZone
        onDropFiles={handleAttach}
        accept={acceptedFileTypes}
        multiple
        disabled={disabled || isLoading || disableFileAttachments}>
        <ChatInputComponent
          ref={chatRef}
          placeholder={t('message')}
          value={value}
          isSending={isLoading}
          disabled={disabled}
          isError={isError}
          errorText={errorText}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          rightActions={VoiceRecord}
          onRemoveAttachment={handleRemoveAttachment}
          attachments={attachments}
          onAddAttachments={handleAttach}
          onSend={handleSend}
          attachmentsMode='inline'
          leftActions={({ canSend, isSending, disabled }) =>
            FileAttach({
              canSend,
              isSending,
              value,
              disabled,
              onAttach: handleAttach,
              disableFileAttachments,
              acceptedFileTypes,
            })
          }
        />
      </DropZone>
    </div>
  );
}

export default ChatInput;

const VoiceRecord = ({ disabled, isSending, value, onChange }) => {
  return <VoiceRecordButton disabled={disabled || isSending} isSending={isSending} value={value} onChange={onChange} />;
};

const FileAttach = ({ disabled, isSending, onAttach, disableFileAttachments, acceptedFileTypes }) => {
  return (
    <FileAttachButton
      disabled={disabled || isSending || disableFileAttachments}
      isSending={isSending}
      onPick={onAttach}
      accept={acceptedFileTypes}
      multiple
    />
  );
};
